import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { LeadsService } from "../services/lead-service/lead-service.service";
import { invalid } from "moment";
import { Router } from "@angular/router";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ProjectsService } from "../services/projects/projects.service";

@Component({
  selector: "invalid-leads",
  templateUrl: "./invalid-leads.component.html",
  styleUrls: ["./invalid-leads.component.css"],
})
export class InvalidLeadsComponent implements OnInit {
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  invalidLeads: any[] = [];
  filterForm: FormGroup;
  projects: any[];
  filter_collapsed = true;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private leadsService: LeadsService,
    private projectService: ProjectsService,
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService
  ) {
    this.initlizeFilterForm();
  }

  ngOnInit() {
    this.getInvalidLeads();
    this.getAllProjects();
  }

  initlizeFilterForm() {
    this.filterForm = this.fb.group({
      keyword: [null],
      project_id: [null],
      date_from: [null],
      date_to: [null],
    });
  }

  getAllProjects() {
    this.projectService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => {
        this.projects = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.complete();
      }
    );
  }

  getInvalidLeads() {
    const params = this.filterForm.value;
    this.slimLoadingBarService.start();
    this.leadsService.getInvalidLeads(params).subscribe(
      (res: any) => {
        this.invalidLeads = res.data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  editLead(lead) {
    localStorage.setItem("invalid_lead", JSON.stringify(lead));
    this.router.navigate(["./pages/addLead", lead.id]);
  }

  deleteLead(lead) {
    this.slimLoadingBarService.start();
    let payload = {
      lead_ids: [lead.id],
    };
    this.leadsService.deleteInvalidLeads(payload).subscribe(
      (res: any) => {
        this.getInvalidLeads();
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  resetFilters() {
    this.filterForm.reset();
    this.getInvalidLeads();
  }
}



// WEBPACK FOOTER //
// ./src/app/invalid-leads/invalid-leads.component.ts